// extracted by mini-css-extract-plugin
export var container = "_dl-0";
export var content = "_dl-3";
export var customerTitle = "_dl-4";
export var empty = "_dl-5";
export var gray = "_dl-6";
export var header = "_dl-7";
export var info = "_dl-8";
export var loading = "_dl-2";
export var loadingCard = "_dl-9";
export var oneLine = "_dl-a";
export var personName = "_dl-e";
export var pillContainer = "_dl-b";
export var selected = "_dl-1";
export var text = "_dl-c";
export var twoLines = "_dl-d";
export var unread = "_dl-f";
export var unreadIndicator = "_dl-g";